export default "__VITE_ASSET__DaBt1dRR__"